import createDataContext from './createDataContext';
import API from '../../apiConfig';
import { moengageTrackEvent, APIErrorTrackEvent } from '../../Analytics/moengageEventFunction';
import moment from 'moment';

const roleObject = {
  isMaster: false,
  isSuperSupplier: false,
  isFalconSeller: false,
  isFalconAdmin: false,
  isFalconMaster: false,
  isFalconOps: false,
};

const authReducer = (state, action) => {
  switch (action.type) {
    default:
      return state;
    case 'signin':
      return { errorMessage: '', login_data: action.payload };
    case 'authStatus':
      return { ...state, isSignedIn: action.payload };
    case 'roleObj':
      return { ...state, roleCheck: action.payload };
    case 'tnc':
      return { ...state, tnc: action.payload };
    case 'workingHrs':
      return { ...state, working: action.payload };
  }
};

const checkLogin = (dispatch) => async () => {
  const login_data = localStorage.getItem('login_data');
  if (login_data) {
    dispatch({ type: 'signin', payload: login_data });
    dispatch({ type: 'authStatus', payload: true });
    dispatch({ type: 'roleObj', payload: roleObject });
    dispatch({ type: 'tnc', payload: login_data && JSON.parse(login_data).tnc ? true : false });
    dispatch({
      type: 'workingHrs',
      payload: login_data && JSON.parse(login_data).working ? true : false,
    });
  } else {
    dispatch({ type: 'authStatus', payload: false });
  }
};

const signin = (dispatch) => {
  return async ({ token, loginData }) => {
    try {
      // const response = await API.post('user/seller/login', {username,otp},{ withCredentials: false });
      // if (response.data.status==='success'){
      //     getAccessRoles(response.data.login_data.role);
      //     await localStorage.setItem('login_data',JSON.stringify(response.data.login_data))
      //     localStorage.setItem('token', JSON.stringify(response.data.token));
      //     dispatch({type:'authStatus', payload:true})
      //     dispatch({type:'roleObj', payload: roleObject})
      //     return response.data.status
      // }
      // else {
      //     alert(response.data.msg);
      // }
      let userLoginData;
      let apiResponse;
      if (loginData) {
        userLoginData = loginData;
      } else {
        apiResponse = await API.post(
          'user/auth/google',
          { token, loginType: 'falcon' },
          { withCredentials: false }
        );
        userLoginData = apiResponse?.data;
      }
      if (userLoginData?.status && userLoginData?.status.toLowerCase() === 'success') {
        localStorage.setItem('token', JSON.stringify(userLoginData.token));

        const userJourney = await API.get('supplier/journey-details');

        const expiresIn = userJourney?.data?.boostDetails?.is_boosted
          ? userJourney?.data?.boostDetails?.expires_at
          : null;

        let dayDifference = 0;

        const journeyCompleted =
          userLoginData?.login_data?.falconBusinessType == 'APOB'
            ? true
            : userJourney?.data?.REGISTRATION_STATUS
            ? userJourney?.data?.REGISTRATION_STATUS?.progress == 100 &&
              userJourney?.data?.INVENTORY_ADDITION_STATUS?.progress == 100 &&
              userJourney?.data?.ORDER_RECIEVED?.progress == 100 &&
              userJourney?.data?.ORDER_ACCEPTED?.progress == 100
            : true;

        if (expiresIn) {
          dayDifference = moment(expiresIn).diff(moment(new Date()), 'days');
        }

        getAccessRoles(userLoginData.login_data.role);

        localStorage.setItem(
          'login_data',
          JSON.stringify({
            ...userLoginData.login_data,
            userJourney: userJourney?.data,
            userJourneyCompleted: journeyCompleted ? true : false,
            salesBoostOn:
              userLoginData?.login_data?.falconBusinessType == 'APOB'
                ? false
                : userJourney?.data?.boostDetails?.is_boosted && dayDifference > 0
                ? true
                : false,
            salesDays: dayDifference,
          })
        );
        dispatch({ type: 'authStatus', payload: true });
        dispatch({ type: 'roleObj', payload: roleObject });
        dispatch({ type: 'tnc', payload: userLoginData.login_data.tnc });
        dispatch({ type: 'workingHrs', payload: userLoginData.login_data.working });
        moengageTrackEvent('User_Sign_In', {
          user_id: userLoginData.login_data.user_id,
          phone_number: userLoginData.login_data.phone_number,
          email: userLoginData.login_data.email,
        });
        return userLoginData;
      } else {
        APIErrorTrackEvent({
          api: apiResponse?.data?.config?.url,
          errorMsg: apiResponse?.data?.msg,
        });
        alert(userLoginData.msg);
      }
    } catch (err) {
      APIErrorTrackEvent({
        api: err?.response?.data?.config?.url,
        errorMsg: err?.response?.data?.msg,
      });
      alert(err);
    }
  };
};

const supplierLogin = (dispatch) => {
  return async ({ token, supplier_id, role, falconBusinessType, sellerName }) => {
    if (token) {
      try {
        getAccessRoles(role);
        localStorage.setItem('token', token);
        localStorage.setItem('turn_over', 'unlimited');
        localStorage.setItem(
          'login_data',
          JSON.stringify({
            falconBusinessType,
            user_id: supplier_id,
            tnc: true,
            working: 1,
            role,
            isAdmin: true,
            sellerName: sellerName || '',
          })
        );
        dispatch({ type: 'authStatus', payload: true });
        dispatch({ type: 'roleObj', payload: roleObject });
        dispatch({ type: 'tnc', payload: true });

        dispatch({
          type: 'workingHrs',
          payload: true,
        });
        return supplier_id;
      } catch (err) {
        alert(err);
      }
    }
  };
};

const logout = (dispatch) => {
  return async () => {
    localStorage.clear();
    try {
      const response = await API.get('user/seller/logout');
      roleObject = {
        isMaster: false,
        isSuperSupplier: false,
        isFalconSeller: false,
        isFalconAdmin: false,
        isFalconMaster: false,
        isFalconOps: false,
      };

      dispatch({ type: 'roleObj', payload: roleObject });
      return response.data.status;
    } catch (err) {
      return null;
    }
  };
};

const isSignedIn = localStorage.getItem('login_data') !== null ? true : false;
const checkTnc =
  localStorage.getItem('login_data') !== null
    ? JSON.parse(localStorage.getItem('login_data')).tnc
      ? true
      : false
    : false;
const checkWorkingHrs =
  localStorage.getItem('login_data') !== null
    ? JSON.parse(localStorage.getItem('login_data')).working
      ? true
      : false
    : false;
const roleObj = () => {
  if (isSignedIn) {
    getAccessRoles(JSON.parse(localStorage.getItem('login_data')).role);
    return roleObject;
  }
};

const updateTnc = (dispatch) => async () => {
  const login_data = JSON.parse(localStorage.getItem('login_data'));
  if (login_data) {
    login_data.tnc = 1;
    dispatch({ type: 'tnc', payload: true });
  }
  localStorage.setItem('login_data', JSON.stringify(login_data));
};

const updateWorkingHrs = (dispatch) => async () => {
  const login_data = JSON.parse(localStorage.getItem('login_data'));

  if (login_data) {
    login_data.working = 1;
    dispatch({ type: 'workingHrs', payload: true });
  }
  localStorage.setItem('login_data', JSON.stringify(login_data));
};

function getAccessRoles(role) {
  switch (role) {
    case 'MASTER': {
      return (roleObject.isMaster = true);
    }
    case 'SUPER_SUPPLIER': {
      return (roleObject.isSuperSupplier = true);
    }
    case 'FALCON_SELLER': {
      return (roleObject.isFalconSeller = true);
    }
    case 'FALCON_ADMIN': {
      return (roleObject.isFalconAdmin = true);
    }
    case 'FALCON_MASTER': {
      return (roleObject.isFalconMaster = true);
    }
    case 'FALCON_OPS': {
      return (roleObject.isFalconOps = true);
    }
  }
}

export const { Provider, Context } = createDataContext(
  authReducer,
  {
    signin,
    supplierLogin,
    checkLogin,
    logout,
    roleObj,
    updateTnc,
    updateWorkingHrs,
  },
  {
    isSignedIn: isSignedIn,
    roleCheck: roleObject,
    tnc: checkTnc,
    workingHrs: checkWorkingHrs,
  }
);
